@if (isLoading()) {
  <edportal-loader />
}
<edportal-nav-menu></edportal-nav-menu>
<video
  id="preview"
  autoplay
  muted
  style="
    display: none;
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    width: 240px;
    border: 2px solid #ccc;
    border-radius: 4px;
    z-index: 9999;
  "
></video>
<main class="px-4" id="main">
  @if (screenShareRequested) {
    <edportal-screen-share-banner [requesterEmail]="screenShareRequesterEmail" />
  }
  <router-outlet></router-outlet>
</main>
<edportal-toast-container />
